import Vue from 'vue'
import Vuex from 'vuex'
import actions from './service/actions'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userid: '',
    email: '',
    level: 0,
    errState: '',
    token: '',
    isAuth: false,
    isSidebar: true
  },
  getters: {
    getUserId: state => state.userid,
    getEmail: state => state.email,
    getLevel: state => state.level,
    getErrState: state => state.errState,
    getToken: state => state.token,
    getAuth: state => state.isAuth
  },
  mutations: {
    toggleSidebar(state) {
      state.isSidebar = !state.isSidebar
    },
    changeUserId(state, payload) {
      state.userid = payload
    },
    changeEmail(state, payload) {
      state.email = payload
    },
    changeLevel(state, payload) {
      state.level = payload
    },
    changeState(state, payload) {
      state.errState = payload
    },
    changeToken(state, payload) {
      state.token = payload
    },
    changeAuth(state, payload) {
      state.isAuth = payload
    }
  },
  actions
});


// WEBPACK FOOTER //
// ./src/store.js